const Tooltip = ({ text }) => {
    return (
        <div className="relative group inline-block">
            <span className="w-5 h-5 bg-gray-300 text-sm rounded-full flex items-center justify-center cursor-pointer">
                ?
            </span>
            <div className="absolute hidden group-hover:block w-64 p-2 bg-black text-white text-xs rounded shadow-md top-full left-1/3 transform -translate-x-3 mt-2 z-10">
                {text}
            </div>
        </div>
    );
};


export default Tooltip;